const e = {
  common: {
    apply: "Apply",
    cancel: "Cancel"
  },
  validation: {
    patternMismatch: "This field contains invalid characters",
    rangeOverflow: "This number is too high",
    rangeUnderflow: "This number is too low",
    stepMismatch: "This number does not fit the allowed step size",
    tooLong: "This text is too long",
    tooShort: "This text is too short",
    typeMismatch: "This value is not of the right type",
    valueMissing: "This field cannot be empty"
  },
  zdsAdvancedSelect: {
    noResults: "No results",
    deleteItemLabel: "Delete Item",
    clearInputLabel: "Clear input",
    closeSelectionLabel: "Close item selection"
  },
  zdsAppbar: {
    searchPlaceholder: "Search"
  },
  zdsCalendar: {
    time: "Time",
    previousMonthLabel: "Previous month",
    nextMonthLabel: "Next month"
  },
  zdsContentReveal: {
    showLess: "Show less",
    showMore: "Show more"
  },
  zdsInputDate: {
    invalidDate: "This is not a valid date ({{format}})",
    dateTooEarly: "The date cannot be before {{minDate}}",
    dateTooLate: "The date cannot be after {{maxDate}}",
    dateNotAvailable: "The selected date is not available",
    dateCannotBeHoliday: "The date cannot be a national holiday",
    dateCannotBeInWeekend: "The date cannot be on the weekend",
    openCalendarLabel: "Open calendar"
  },
  zdsNavigation: {
    skipToContent: "Skip to main content"
  },
  zdsPagination: {
    ariaLabel: "Page navigation",
    ariaNextLabel: "Next page",
    ariaPreviousLabel: "Previous page",
    ariaPagePrefix: "Page {{pageIndex}}"
  },
  zdsUpload: {
    dropAFileHere: "Drop a file here",
    or: "or",
    selectAFile: "select a file",
    fileSelected: "file selected",
    filesSelected: "files selected",
    maxFilesReached: "Reached the maximum number of files",
    validation: {
      fileSizeExceeded: "File size ({{filesize}} MB) exceeds the maximum: {{maxFilesize}} MB",
      fileTypeNotSupported: "File type is not supported, use: {{fileTypes}}",
      responseError: "Something went wrong when uploading, try again later",
      maxOneFile: "You can only select 1 file",
      maxFilesExceeded: "You can only select {{maxFiles}} files",
      fileSizeTotalExceeded: "The total file size ({{totalFileSize}} MB) exceeds the maximum of {{maxTotalFileSize}} MB",
      badFileResponse: "Something went wrong when uploading"
    },
    labels: {
      download: "Download file",
      delete: "Delete file"
    }
  },
  zdsInputRecipient: {
    invalidEmail: '"{{value}}" is not a valid email address',
    removeChipLabel: "Remove recipient"
  },
  zdsVideo: {
    playLabel: "Play video"
  },
  zdsTabs: {
    labels: {
      scrollLeft: "Scroll Left",
      scrollRight: "Scroll Right"
    }
  },
  zdsTab: {
    moreTabsLabel: "Close Tab"
  },
  zdsSideSheet: {
    labels: {
      collapse: "Collapse side menu",
      resize: "Resize menu"
    }
  },
  zdsNavigationPanel: {
    backLabel: "Go back",
    closeLabel: "Close"
  },
  zdsInputTime: {
    clockLabe: "Open time suggestions"
  },
  zdsInputPassword: {
    showPasswordLabel: "Show password",
    hidePasswordLabel: "Hide Password"
  },
  zdsInputContentContainer: {
    rejectLabel: "Reject",
    acceptLabel: "Accept",
    clearLabel: "Clear input"
  },
  zdsDrawer: {
    closeLabel: "Close"
  },
  zdsDataTable: {
    sortLabel: "Sort table"
  },
  zdsChip: {
    deleteLabel: "Delete Chip"
  },
  zdsCarousel: {
    closeFullscreen: "Close fullscreen mode",
    slideLeftLabel: "Slide left",
    slideRightLabel: "Slide Right"
  }
}, a = {
  common: {
    apply: "Ok",
    cancel: "Annuleren"
  },
  validation: {
    patternMismatch: "Dit veld bevat ongeldige tekens",
    rangeOverflow: "De opgegeven waarde is te hoog",
    rangeUnderflow: "De opgegeven waarde is te laag",
    stepMismatch: "De opgegeven waarde valt niet binnen de mogelijke stappen",
    tooLong: "De opgegeven waarde is te lang",
    tooShort: "De opgegeven waarde is te kort",
    typeMismatch: "De opgegeven waarde heeft niet het juiste type",
    valueMissing: "Dit veld mag niet leeg zijn"
  },
  zdsAdvancedSelect: {
    noResults: "Geen resultaten",
    deleteItemLabel: "Verwijder item",
    clearInputLabel: "Wis invoer",
    closeSelectionLabel: "Sluit itemselectie"
  },
  zdsAppbar: {
    searchPlaceholder: "Zoeken"
  },
  zdsCalendar: {
    time: "Tijd",
    previousMonthLabel: "Vorige maand",
    nextMonthLabel: "Volgende maand"
  },
  zdsContentReveal: {
    showLess: "Toon minder",
    showMore: "Toon meer"
  },
  zdsInputDate: {
    invalidDate: "Dit is geen geldige datum ({{format}})",
    dateTooEarly: "De datum mag niet eerder zijn dan {{minDate}}",
    dateTooLate: "De datum mag niet later zijn dan {{maxDate}}",
    dateNotAvailable: "De geselecteerde datum is niet beschikbaar",
    dateCannotBeHoliday: "De datum mag geen nationale feestdag zijn",
    dateCannotBeInWeekend: "De datum mag niet in het weekend liggen",
    openCalendarLabel: "Open kalender"
  },
  zdsNavigation: {
    skipToContent: "Direct naar hoofdinhoud"
  },
  zdsPagination: {
    ariaLabel: "Pagina navigatie",
    ariaNextLabel: "Volgende pagina",
    ariaPreviousLabel: "Vorige pagina",
    ariaPagePrefix: "Pagina {{pageIndex}}"
  },
  zdsUpload: {
    dropAFileHere: "Sleep een bestand hierheen",
    or: "of",
    selectAFile: "Selecteer een bestand",
    fileSelected: "bestand geselecteerd",
    filesSelected: "bestanden geselecteerd",
    maxFilesReached: "Maximaal aantal bestanden bereikt",
    validation: {
      fileSizeExceeded: "Bestandsgrootte ({{filesize}} MB) overschrijdt het maximum: {{maxFilesize}} MB",
      fileTypeNotSupported: "Bestandstype wordt niet ondersteund, gebruik: {{fileTypes}}",
      responseError: "Er ging iets fout met de upload, probeer het later opnieuw",
      maxOneFile: "Er mag slechts 1 bestand worden geselecteerd",
      maxFilesExceeded: "Er mogen slechts {{maxFiles}} bestanden worden geselecteerd",
      fileSizeTotalExceeded: "De totale bestandsgrootte ({{totalFileSize}} MB) overschrijdt het maximum van {{maxTotalFileSize}} MB",
      badFileResponse: "Er ging iets fout met de upload"
    },
    labels: {
      download: "Download bestand",
      delete: "Verwijder bestand"
    }
  },
  zdsInputRecipient: {
    invalidEmail: '"{{value}}" is geen geldig e-mailadres',
    removeChipLabel: "Verwijder ontvanger"
  },
  zdsVideo: {
    playLabel: "Video afspelen"
  },
  zdsTabs: {
    labels: {
      scrollLeft: "Scroll naar links",
      scrollRight: "Scroll naar rechts"
    }
  },
  zdsTab: {
    moreTabsLabel: "Meer tabbladen"
  },
  zdsSideSheet: {
    labels: {
      collapse: "Vouw zijmenu in",
      resize: "Herformatteer menu"
    }
  },
  zdsNavigationPanel: {
    backLabel: "Teruggaan",
    closeLabel: "Sluiten"
  },
  zdsInputTime: {
    clockLabel: "Open tijdsuggesties"
  },
  zdsInputPassword: {
    showPasswordLabel: "Toon wachtwoord",
    hidePasswordLabel: "Verberg wachtwoord"
  },
  zdsInputContentContainer: {
    rejectLabel: "Afwijzen",
    acceptLabel: "Accepteren",
    clearLabel: "Wis invoer"
  },
  zdsDrawer: {
    closeLabel: "Sluiten"
  },
  zdsDataTable: {
    sortLabel: "Sorteer tabel"
  },
  zdsChip: {
    deleteLabel: "Verwijder chip"
  },
  zdsCarousel: {
    closeFullscreen: "Sluit de fullscreen-modus",
    slideLeftLabel: "Schuif naar links",
    slideRightLabel: "Schuif naar rechts"
  }
};
export {
  e as enTranslations,
  a as nlTranslations
};
